import { FaFutbol, FaTrophy, FaMedal } from "react-icons/fa";
import "./player-card.css";

interface PlayerCardProps {
  name: string;
  goals: number;
  textGoal: string;
  position?: number;
  ownGoal?: boolean;
}

export const PlayerCard = ({
  name, goals, textGoal, position, ownGoal = false,
}: PlayerCardProps): JSX.Element => {
  const words = (name || "?").trim().split(/\s+/);
  const initials = (words[0].charAt(0) + (words.length > 1 ? words[words.length - 1].charAt(0) : "")).toUpperCase();
  const podium = !ownGoal && position !== undefined && position >= 1 && position <= 3;
  const displayGoals = ownGoal ? -Math.abs(goals) : goals;

  return (
    <article className={`player-card${ownGoal ? " player-card--own-goal" : ""}`} data-podium={podium ? position : undefined}>
      {position !== undefined && (
        <span className="player-card__position" aria-label={`${position} no ranking`}>
          <span aria-hidden="true">{String(position).padStart(2, "0")}</span>
        </span>
      )}
      <span className="player-card__avatar" aria-hidden="true">{initials}</span>
      <div className="player-card__identity">
        <h2 className="player-card__name">{name}</h2>
        <span className="player-card__caption">
          {podium ? (
            <><span aria-hidden="true">{position === 1 ? <FaTrophy /> : <FaMedal />}</span>{position === 1 ? "Artilheiro" : "Top 3"}</>
          ) : ownGoal ? "Gols contra" : "Na disputa"}
        </span>
      </div>
      <div className="player-card__score">
        <strong>{displayGoals}</strong>
        <span><FaFutbol aria-hidden="true" />{textGoal}</span>
      </div>
    </article>
  );
};
